import { z } from 'zod'

import { GetUserSchema } from './user.ts'

export const GetVerificationSchema = z.object({
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
  user: GetUserSchema,
})
